import { Heading, type HeadingProps } from '@chakra-ui/react'

interface SectionLabelProps extends HeadingProps {
  children: React.ReactNode
}

/** The design's `<h6>` section label: 13px uppercase Archivo 800 in deep accent. */
export const SectionLabel = ({ children, ...props }: SectionLabelProps) => (
  <Heading
    as="h6"
    fontSize="13px"
    fontWeight="800"
    letterSpacing="0.08em"
    textTransform="uppercase"
    lineHeight="1.12"
    color="accent.700"
    {...props}
  >
    {children}
  </Heading>
)
